import { render, staticRenderFns } from "./DistroStockCounts.vue?vue&type=template&id=12d4654f&scoped=true"
import script from "./DistroStockCounts.vue?vue&type=script&lang=js"
export * from "./DistroStockCounts.vue?vue&type=script&lang=js"
import style0 from "./DistroStockCounts.vue?vue&type=style&index=0&id=12d4654f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4654f",
  null
  
)

export default component.exports